import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import {useTranslation} from "react-i18next";
import { Close as CloseIcon } from '@vedmarket/ui-kit';
import { Search as SearchIcon } from '@vedmarket/ui-kit';

const SupplierSearchField = ({
  onChange,
  onClear,
  value,
}: SupplierSearchFieldProps ) => {
  const { t } = useTranslation()

  return <TextField
    label={t("common__text__search")}
    fullWidth
    value={value}
    onChange={({ target: { value: nextValue } }) => onChange(nextValue)}
    InputLabelProps={{shrink: true}}
    InputProps={{
      endAdornment: <InputAdornment position='end'>
        {value ? <IconButton
          onClick={onClear}
          size='small'
          sx={{
            marginRight: value ? '-4px !important' : 0,
          }}
        >
          <CloseIcon />
        </IconButton> : <SearchIcon/>}
      </InputAdornment>
    }}
  />
}

export default SupplierSearchField
